import { MatDialogRef } from "@angular/material/dialog";
import { Component, ViewEncapsulation, ElementRef } from "@angular/core";
import { DialogPanelComponentContent } from "@toro/common/shared/models/dialogs/DialogPanelComponentContent";
import { Store } from "@ngrx/store";
import { AppState } from "@toro/common/shared/interfaces/app-state.interface";
import { DialogsService } from "@toro/common/shared/services/dialogs.service";
import { CheckoutWrapperComponent } from "../../wrapper/checkout-wrapper.component";
@Component({
  templateUrl: "./checkout-about-fees.component.html",
  styleUrls: ["./checkout-about-fees.component.scss"],
  encapsulation: ViewEncapsulation.Emulated,
})

export class CheckoutAboutFeesComponent extends DialogPanelComponentContent {
  public closingTimeDayTrade: string | Date;
  public closingTimeBovespa: string | Date;

  constructor(
    public elementRef: ElementRef,
    public store: Store<AppState>,
    private dialogReference: MatDialogRef<CheckoutAboutFeesComponent>,
    protected dialogsServices: DialogsService,
  ) {
    super(elementRef, true);

    this.store.select((store) => store.exchange.tradingTime)
    .subscribe((data) => {
        this.closingTimeBovespa = data.limitDayTradeStock;
        this.closingTimeDayTrade = data.limitDayTradeFuture;
    })
  }

    /**
   * Fecha o modal
   * @param confirm
   */
    public closeDialog(confirm: boolean) {
      super.close(this.dialogReference, confirm);
    }
    
}
